import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, FormattedRelative } from 'react-intl';
import moment from 'moment-timezone';
import messages from '../../text/messages';
import { dismissNotification } from '../../reducers/notifications';

import './alert.css';
import { ALERT_ICONS } from '../../text/enumerations';

class Alert extends React.Component {
    constructor(props) {
        super(props);

        this.renderAction = this.renderAction.bind(this);
    }

    renderAction() {
        const { notification, noDismiss, dismissNotification } = this.props;
        if (notification.url) {
            return (
                <div
                    className="col-xs-12 alert-action no-select"
                    onClick={() => {
                        window.location = notification.url;
                    }}
                >
                    {notification.url_text || <FormattedMessage {...messages.clickHere} />}
                </div>
            );
        }

        if (noDismiss || notification.type !== 'regular') {
            return null;
        }

        return (
            <div className="col-xs-12 alert-action no-select" onClick={() => dismissNotification(notification)}>
                <FormattedMessage {...messages.dismiss} />
            </div>
        );
    }

    render() {
        const { notification } = this.props;
        const { type, message, subject, updated_at, priority } = notification;
        const icon = priority === 'urgent' ? 'warning' : ALERT_ICONS[type] || 'error_outline';
        const subtitle = priority === 'urgent' ? <FormattedMessage {...messages.urgent} /> : <FormattedRelative value={moment(updated_at).toDate()} />;

        return (
            <div className={`alert-container ${priority}`}>
                <div className="row">
                    <i className="col-xs-2 alert-icon material-icons no-select">{icon}</i>
                    <div className="col-xs-10 col-xs-offset-2 alert-content">
                        <div className="row">
                            <div className="col-xs-12 alert-subtitle">{subtitle}</div>
                            {subject && <div className="col-xs-12 alert-message">{subject}</div>}
                            {message && <div className="col-xs-12 alert-message">{message}</div>}
                            {this.renderAction()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Alert.defaultProps = {
    notification: undefined,
    action: undefined,
    noDismiss: true
};
Alert.propTypes = {
    notification: PropTypes.object.isRequired,
    action: PropTypes.object,
    noDismiss: PropTypes.bool
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            dismissNotification
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Alert);



// WEBPACK FOOTER //
// ./src/components/alert/index.jsx